/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Sent_BodyInputs */

const en_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We read every one of these, and they decide what we add next.`)
};

const zh_hans1_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一条我们都会看，它们决定了我们接下来添加什么。`)
};

const pt_br2_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lemos cada uma delas, e são elas que decidem o que adicionamos em seguida.`)
};

const es_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leemos cada uno de estos mensajes, y deciden qué agregamos después.`)
};

const fr_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous lisons chacun de ces messages, et ils décident de ce que nous ajoutons ensuite.`)
};

const de_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir lesen jede dieser Nachrichten, und sie entscheiden, was wir als Nächstes ergänzen.`)
};

const ru_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы читаем каждое сообщение, и по ним решаем, что добавлять дальше.`)
};

const it_feedback_sent_body = /** @type {(inputs: Feedback_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggiamo ogni messaggio, e sono questi a decidere cosa aggiungiamo dopo.`)
};

/**
* | output |
* | --- |
* | "We read every one of these, and they decide what we add next." |
*
* @param {Feedback_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_sent_body = /** @type {((inputs?: Feedback_Sent_BodyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Sent_BodyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_sent_body(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_sent_body(inputs)
	if (locale === "es") return es_feedback_sent_body(inputs)
	if (locale === "fr") return fr_feedback_sent_body(inputs)
	if (locale === "de") return de_feedback_sent_body(inputs)
	if (locale === "ru") return ru_feedback_sent_body(inputs)
	if (locale === "it") return it_feedback_sent_body(inputs)
	return en_feedback_sent_body(inputs)
});